import { Country } from '@interfaces/Country';
import { LATAM_COUNTRIES, EXTRA_COUNTRIES } from '@utils/countries';

const formatter = (country: Country) => {
  return {
    value: country.countryCode.toString(),
    label: `+${country.countryCode}`,
    flag: country.flag,
  };
};

const formattedLatamCountries = LATAM_COUNTRIES.map((country) => formatter(country));
const formattedExtraCountries = EXTRA_COUNTRIES.map((country) => formatter(country));

export const formattedCountries = [...formattedLatamCountries, ...formattedExtraCountries].sort((a, b) =>
  a.label.localeCompare(b.label),
);
